import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BudgetAllocation from "./BudgetAllocation";
import { setTotalBudget } from "../../slices/totalBudgetSlice";
import CTextField from "../../components/CTextField";
import { formatZAR } from "../../constant/utils/commonUtils";

const BudgetConfiguration = () => {
  const dispatch = useDispatch();
  const { totalBudget } = useSelector((state) => state.totalBudget);
  return (
    <div className="min-h-[calc(100vh-116px)]">
      <div className="flex gap-2 items-center justify-between">
        <h2 className="2xl:text-3xl 2xl:leading-3xl text-2xl leading-2xl text-blue-500 font-semibold">
          Department Budget
        </h2>
        <div className="flex items-center gap-4 accordion-steppers-fields ">
          <div className="relative flex items-center gap-2">
            <span className="text-gray-700 font-semibold text-xl leading-xl">Total Budget:</span>
            <p className="text-blue-500 font-semibold text-xl leading-xl">{formatZAR(totalBudget)}</p>
          </div>
        </div>
      </div>
      <BudgetAllocation />
    </div>
  );
};

export default BudgetConfiguration;
